import { FiltersV2StoreContextProvider } from "PFApp/components/filters_v2";
import NotFoundComponent from "PFComponents/not_found/not_found";
import { PageWrapper } from "PFComponents/page_wrapper";
import { PageTarget } from "PFTypes/saved_filters";
import { useTranslation } from "react-i18next";

import { ProfilesPageContextProvider, useProfilesPageContext } from "./context";
import { ProfilesPage } from "./profiles_page";

const ProfilesPageController = () => {
  const { t } = useTranslation(["translation", "profiles"]);
  const { error } = useProfilesPageContext();
  return (
    <PageWrapper
      errors={error ? [error] : []}
      errorComponent={
        <NotFoundComponent
          message={t("profiles:list.notFoundMessage")}
          buttonMessage={t("translation:comeBackLater")}
          buttonUrl="/profiles"
        />
      }
    >
      <ProfilesPage />
    </PageWrapper>
  );
};

export const ProfilesPageControllerWrapper = () => (
  <FiltersV2StoreContextProvider collection={PageTarget.Profiles}>
    <ProfilesPageContextProvider>
      <ProfilesPageController />
    </ProfilesPageContextProvider>
  </FiltersV2StoreContextProvider>
);
